import { createContext, useState, useContext, ReactNode } from 'react';
import { Wishlist } from "@/api/types.ts";

interface WishlistContext {
  wishlist: Wishlist | undefined;
  setWishlist: (wishlist: Wishlist | undefined) => void;
}

const WishlistContext = createContext<WishlistContext|undefined>(undefined);

export const WishlistProvider = ({ children }:{children: ReactNode}) => {
  const [wishlist, setWishlist] = useState<Wishlist | undefined>(undefined);

  return (
    <WishlistContext.Provider value={{ wishlist, setWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = (): WishlistContext => {
  const context = useContext(WishlistContext);

  if (context === undefined) {
    throw new Error('useWishlist must be used within a WishlistProvider');
  }

  return context;
};
